import { useAtom } from 'jotai';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePopper } from 'react-popper';
import { Link } from 'react-router-dom';
import { authAtom } from '../../atoms';
import { USER_ROLE } from '../../lib/constants';
import { cln } from '../../lib/utils';
import { PATHS } from '../../lib/paths';
import { useOnClickOutside } from '../../hooks';

export function CreateMenu() {
  const { t } = useTranslation();
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [auth] = useAtom(authAtom);
  const createMenuRef = useRef<HTMLDivElement>(null);
  const [triggerEl, setTriggerEl] = useState<HTMLButtonElement | null>(null);
  const [popperEl, setPopperEl] = useState<HTMLUListElement | null>(null);
  const { attributes, styles } = usePopper(triggerEl, popperEl, { placement: 'bottom-end' });
  useOnClickOutside(createMenuRef.current, () => setMenuOpen(false));

  return (
    <div ref={createMenuRef}>
      <button
        ref={setTriggerEl}
        className="primary-fill"
        onClick={() => setMenuOpen((prev) => !prev)}
      >
        {t('navigation.create')}
      </button>
      <ul
        ref={setPopperEl}
        style={styles.popper}
        {...attributes.popper}
        className={cln(
          !isMenuOpen && 'hidden',
          'bg-neutral-50 py-1 rounded shadow-xl normal-case min-w-[10rem] z-20',
        )}
      >
        <li>
          <Link
            role="button"
            className="justify-start gap-4 hover:text-neutral-900"
            to={PATHS.newReportPath()}
          >
            <i className="ri-bug-line font-normal" />
            {t('navigation.report')}
          </Link>
        </li>
        {auth?.user?.role === USER_ROLE.SUPERADMIN && (
          <>
            <li>
              <Link
                role="button"
                className="justify-start gap-4 hover:text-neutral-900"
                to={PATHS.newProjectPath()}
              >
                <i className="ri-table-line font-normal" />
                {t('navigation.project')}
              </Link>
            </li>

            <li>
              <Link
                role="button"
                className="justify-start gap-4 hover:text-neutral-900"
                to={PATHS.newUserPath()}
              >
                <i className="ri-user-line font-normal" />
                {t('navigation.user')}
              </Link>
            </li>
          </>
        )}
      </ul>
    </div>
  );
}
